<template>
  <TableGradient
      icon-name="ticket"
      :title="$t('attribute.listagem.titulo_pagina')"
      :text-empty="$t('attribute.listagem.table.empty')"
      route-new="vns.attribute.create"
      :text-new="$t('attribute.listagem.novo')"
      :fields="fields"
      :fields-filter="filter"
      :items="attributes"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('attribute/listAll', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="`link-edit-${linha.index}`" :to="{ name: 'vns.attribute.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('attribute.listagem.table.editar') }}
      </router-link>
    </template>
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.status, 'badge badge-danger': !linha.item.status}">
          <i :class="linha.item.status ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      attributes: 'attribute/all',
      paginator: 'attribute/pagination',
      store_isLoading: 'attribute/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('attribute.listagem.table.nome'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('attribute.listagem.table.editar')}
      ],
      filter: [
        {key: 'name', label: this.$t('attribute.listagem.table.nome')},
      ]
    }
  },
  methods: {
    ...mapActions([
      'attribute/listAll'
    ])
  },
  mounted() {
    this['attribute/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
